function AriaTabindex() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A tabindex value of 0 or less is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Tabindex can facilitate keyboard navigation for interactive elements. A tabindex attribute value of 0 places an item into the keyboard navigation order (i.e., you can navigate to it using the Tab key). A value of less than 0 (typically -1) removes an element from the keyboard flow (you cannot Tab to it), but allows it to receive programmatic focus (e.g., via scripting).</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that tabindex is being used correctly by navigating and interacting with the elements using only the keyboard. Positive tabindex values specify a distinct tab order and should typically be avoided.</p>
    </blockquote>
  )
}

export default AriaTabindex